import { render, staticRenderFns } from "./MpSiderNav.vue?vue&type=template&id=276f46bf&scoped=true&"
import script from "./MpSiderNav.vue?vue&type=script&lang=js&"
export * from "./MpSiderNav.vue?vue&type=script&lang=js&"
import style0 from "./MpSiderNav.vue?vue&type=style&index=0&id=276f46bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276f46bf",
  null
  
)

export default component.exports